export const orthographicCameraType = 'orthographic'
export const perspectiveCameraType = 'perspective'

export type CameraType =
  | typeof orthographicCameraType
  | typeof perspectiveCameraType
